/**
 * Taken from zod-formik-adapter package which is out-of-date and
 * apparanelty unmaintained. Luckily it consists of only one module as
 * seen here.
 *
 * @module
 * @see https://github.com/robertLichtnow/zod-formik-adapter/blob/master/index.ts
 * @todo Move to a better package in the monorepo rather than hijacking
 *   gaia-family/dom
 */

import { z } from 'zod'

// eslint-disable-next-line no-restricted-globals
export class ValidationError extends Error {
  name = 'ValidationError'
  inner: Array<{ path: string; message: string }> = []
}

const createValidationError = (e: z.ZodError) => {
  const error = new ValidationError(e.message)
  error.inner = e.errors.map((err) => ({
    message: err.message,
    path: err.path.join('.'),
  }))

  return error
}

/**
 * Wrap your zod schema in this function when providing it to Formik's
 * validation schema prop
 *
 * @param schema The zod schema
 * @returns An object containing the `validate` method expected by
 *   Formik
 */
export const toFormikValidationSchema = <T>(
  schema: z.ZodSchema<T>,
  params?: Partial<z.ParseParams>
): { validate: (obj: T) => Promise<void> } => {
  return {
    async validate(obj: T) {
      try {
        await schema.parseAsync(obj, params)
      } catch (err: unknown) {
        throw createValidationError(err as z.ZodError<T>)
      }
    },
  }
}
